export type HelpScope = 'platform' | 'platformDefault' | 'endpoint';

export const HELP_SCOPE_BY_KEY: Readonly<Record<string, HelpScope>> = {
  'WStudio.user.listWithFilters': 'endpoint',
  'WStudio.sales.listSales': 'endpoint',
  'WStudio.sales.listForUser': 'endpoint',
  'WStudio.report.checkin': 'endpoint',
  'WStudio.product.listByType': 'endpoint',
  'WStudio.user.listWithFilters.filter': 'endpoint',
  'WStudio.user.listWithFilters.filters': 'endpoint',
  'WStudio.user.listWithFilters.max': 'endpoint',
  'WStudio.user.listWithFilters.offset': 'endpoint',
  'WStudio.sales.listForUser.max': 'endpoint',
  'WStudio.sales.listForUser.offset': 'endpoint',
  'WStudio.sales.listForUser.forceUpdate': 'endpoint',
  'WStudio.product.listByType.max': 'endpoint',
  'WStudio.product.listByType.offset': 'endpoint',
  'WStudio.product.types': 'platform',
  'WStudio.membership.gracePeriodDays': 'platformDefault',
  'WStudio.membership.shortTermThresholdDays': 'platformDefault',
  'WStudio.membership.renewalDueSoonDays': 'platformDefault',
  'WStudio.membership.tenureEstablishedDays': 'platformDefault',
  'WStudio.membership.tenureLoyalDays': 'platformDefault',
  'WStudio.membership.productFamilyByCategory': 'platformDefault',
  'WStudio.membership.valueMidThreshold': 'platformDefault',
  'WStudio.membership.valueHighThreshold': 'platformDefault',
  'WStudio.genesis.syncReadyCoverageDays': 'platformDefault',
  'GhlFieldMappings.CONTACT_PREFIX': 'platform',
};

export const HELP_SCOPE_FALLBACK: Readonly<Record<HelpScope, string>> = {
  platform: 'Platform',
  platformDefault: 'Platform default',
  endpoint: 'Endpoint',
};
